import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

export default function PhaseNameInputBox({ phase, phaseIndex }) {
    const { mode, mutatePhase } = useContext(WorkoutTemplateBuilderContext)

    return (
        <input
            type="text"
            name="phaseName"
            id="phaseName"
            className="h-8 flex-grow rounded-t-lg text-base px-2 disabled:bg-white rounded-b-lg"
            placeholder={'Phase ' + (phaseIndex + 1)}
            value={phase.name}
            onChange={(event) => mutatePhase('change-phase-name', phaseIndex, event.target.value)}
            disabled={mode === 'view' ? true : false}
        />
    )
}
